export const CONTENT_QUERY_LINK = 'linksContent';
